import React from 'react';
import PropTypes from 'prop-types';
import { MetadataPropTypesShape } from '@Components/Results/MetadataPropTypes';
import * as Spinners from '@Services/Spinners';
import RxSpinnerComponent from '@Components/Results/utils/rx-spinner.component.jsx';
import ShowMoreComponent from '@Components/Results/utils/show-more.component.jsx';
import SubstanceQualitativeTableComponent from '@Components/Results/substances/tables/qualitative/substance-qualitative-table.component.jsx';

export default class SubstanceQualitativeData extends React.PureComponent {

  constructor(props) {
    super(props);

    const { data, uniqueId } = props;

    this.state = { data };

    this.cache = null;
    this.id = `${uniqueId}-qualitative`;
  }

  showMore(firstItem, lastItem) {
    return new Promise((resolve, reject) => {
      if (this.cache) {
        this.appendRows(this.cache);
        this.cache = null;
        return resolve();
      }

      Spinners.activate(this.id);

      return this.props
        .retrieveData(firstItem, lastItem)
        .then(rows => {
          this.appendRows(rows);
          this.props.track && this.props.track(rows, 'showMoreBio', null, firstItem, lastItem);
          return rows;
        })
        .catch(() => reject(new Error('No qualitative data found')))
        .finally(() => {
          Spinners.terminate(this.id);
          return resolve();
        });
    });
  }

  appendRows(rows) {
    const data = [...this.state.data].concat(rows);
    this.setState({ data });
  }

  showLess() {
    const { initialItemsAmount } = this.props;
    const data = [...this.state.data];

    this.cache = data.splice(initialItemsAmount);
    this.setState({ data });
  }

  render() {
    const { metadata, total, showTitle, initialItemsAmount } = this.props;
    const { data } = this.state;

    return (
      <div className="substance-results-qualitative" id={this.id}>
        {showTitle && (
          <div className="typography-small">
            <strong>Qualitative Results</strong>
          </div>
        )}

        <SubstanceQualitativeTableComponent metadata={metadata} data={data} total={total} />

        <RxSpinnerComponent spinnerId={this.id} position="relative" />

        <div className="rx-btn-group--center">
          <ShowMoreComponent
            initial={initialItemsAmount}
            current={data.length}
            total={total}
            container={`#${this.id}`}
            moreHandler={({ firstItem, lastItem }) => this.showMore(firstItem, lastItem)}
            lessHandler={() => this.showLess()}
          />
        </div>
      </div>
    );
  }
}

SubstanceQualitativeData.defaultProps = {
  initialItemsAmount: 7,
};

SubstanceQualitativeData.propTypes = {
  metadata: MetadataPropTypesShape,
  total: PropTypes.number.isRequired,
  data: PropTypes.array.isRequired,
  uniqueId: PropTypes.string.isRequired,
  retrieveData: PropTypes.func.isRequired,
  track: PropTypes.func,
  showTitle: PropTypes.bool,
  initialItemsAmount: PropTypes.number,
};
